import './global.less';
import { Link, Route, Routes, Navigate, } from 'react-router-dom';
import Jobs from './pages/Jobs/Jobs';

import Auth from './pages/Auth/Auth';
import React from 'react';

import Users from './pages/Users/Users';
import JobDetails from './pages/JobDetails/JobDetails';
import ProtectedRoute from './components/ProtectedRoute';
import User from './pages/User/User';
import Reviews from './pages/Reviews/Reviews';
import Patient from './pages/Patient/Patient';
import Invoice from './pages/Invoice/Invoice';
import PartnerRequests from './pages/Partners/PartnerRequests';


function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/auth" element={<Auth />} />
        <Route element={<ProtectedRoute />}>
          <Route
            path="/"
            element={<Navigate to={"/jobs"} />}
          />
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/jobs" element={<Jobs />} />
          <Route path="/jobs/:id" element={<JobDetails />} />
          <Route path="/users" element={<Users />} />
          <Route path="/invoices" element={<Invoice />} />
          <Route path={"/profile/:type/:id"} element={<User />} />
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/patients/:id" element={<Patient />} />
          <Route path="/partner-requests" element={<PartnerRequests />} />
        </Route>
      </Routes>
    </div>
  );
}


export default App;
